import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import SideNavigationMenu from "./common/SideNavigationMenu";
import MyOptionsPage from "./MyOptions/MyOptionsPage";
import EmployeeOptionsPage from "./Employee/EmployeeOptionsPage";
import ExerciseOptionsPage from "./Employee/ExerciseOptionsPage";
import ExerciseRequestApprovalPage from "./Employee/ExerciseRequestApprovalPage";
import { Row, Col } from "react-bootstrap";
import PlanDetailsDefault from "./Plan/details/PlanDetailsDefault";
import PlanAdminRouting from "./Plan/PlanAdminRouting";
import CurrentPricePage from "./CurrentPrice/CurrentPricePage";
import AddPriceForm from "./CurrentPrice/AddPriceForm";
import EditPriceForm from "./CurrentPrice/EditPriceForm";
import FaqPage from "./Faq/Faq";

const OptionsPages = (props) => {

    return (
    <>
      <Col className="rev-share-nav" xl="2" lg="3" md="4">
        <SideNavigationMenu isGhost={props.profile.ghost} isAdmin={props.profile.isAdmin} isManager={props.profile.isManager} />
      </Col>
      <Col xl="10" lg="9" md="8">
        <Row>
          <Switch>           
            <Route exact path="/options/myoptions" component={MyOptionsPage} />
            <Route exact path="/options/employees/:employeeId?" component={EmployeeOptionsPage} />
            <Route exact path="/options/employees/:employeeId/exercise" component={ExerciseOptionsPage} />
            <Route exact path="/options/exercise-requests/:exerciseRequestId" component={ExerciseRequestApprovalPage} />
            <Route exact path="/options/plans" component={PlanDetailsDefault} />
            <Route exact path="/options" component={MyOptionsPage} />
            <Route exact path="/options/stockprice" component={CurrentPricePage} />
            <Route exact path="/options/stockprice/add" component={AddPriceForm} />
            <Route exact path="/options/stockprice/:priceId" component={EditPriceForm} />
            <Route exact path="/options/faq" component={FaqPage} />
            <Route path="/options/plans/:planIdOrCmd" component={PlanAdminRouting} />
          </Switch>
        </Row>
      </Col>
    </>
  ); 
};

const mapStateToProps = (state, ownProps) => {
  return { profile: state.profile };
};

export default connect(mapStateToProps)(OptionsPages);